import { Button, Modal, ModalBody, ModalHeader , Table, Row, Col, Card } from "reactstrap";
import { useMemo, useState,useEffect, useCallback } from "react";
import ViewSupportingProductPopUp from "./ViewSupportingProductPopUp";
import { usePopUpWrapper } from "./index";
import { calculateTotalShipment ,calculatePrice, getDistributorOptions } from '../../utils/commenController' 

const ViewPopUp = ({
  viewModal,
  handleShowViewModal,
  formattedSavedProductsData,
  formattedSupportingProduct
}) => {
  const { fetchMainProductRelateSupportingProducts,  
          sectionBaseSavedProducts, 
          setSectionBaseSavedProducts, 
          setNotSectionBaseSaveProducts,
          appStandardMarkup,
          isSectionActive ,
          pricingPolicy,
          isEditQuotation,
          setQuotationProductData,
          setSectionItems,
          setIsUpdateProductButtonNoSection,
          setIsUpdateProductButtonSection,
          setSelectedProduct
        } = usePopUpWrapper();

  const [viewSupportingModal, setViewSupportingModal] = useState(false);


  const [sectionData, setSectionData] = useState({})
  const [productCode, setProductCode] = useState('');
  const [updatedProductSupportedData, setUpdatedProductSupportedData] = useState({});
  const [productRelateSupportingProduct, setProductRelateSupportingProduct] = useState({}) //Product relate supporting products

  
  // #Resetting  
  useEffect(()=>{
    setProductRelateSupportingProduct({})
    setUpdatedProductSupportedData({})
  },[isSectionActive])


  const cachedFrormattedSupportingProduct =  useMemo(()=>{
        return formattedSupportingProduct
  },[formattedSupportingProduct])

  
  useEffect(()=>{
    /* 
     * In the case of edit adding  supporting product
     */
    if(isEditQuotation ){
      setProductRelateSupportingProduct(cachedFrormattedSupportingProduct)
    }
  },[isEditQuotation, cachedFrormattedSupportingProduct])

  const supportingProduct = useMemo(()=>{
    return productRelateSupportingProduct;
  },[productRelateSupportingProduct])



  // Fetching supporting product data from Api and data caching
  const handleShowSupportingProductViewModal = async(productId, productCode, pricingPolicy) => {
    // try{  

      const { sectionName, section, sectionIndex } = formattedSavedProductsData

      switch(section){
        case 'MAIN_SECTION':

          
          let finalOutputSection  = []
          if(isEditQuotation  && supportingProduct[sectionIndex]?.products?.[productCode]?.length !==0){
              /* 
               * FOR GETTING ALL SUPPORTING PRODUCT   
               */              
              const productData = await fetchMainProductRelateSupportingProducts(productId);
      
              for (let item of productData) {
                const matchingProducts = supportingProduct[sectionIndex]?.products?.[productCode] || [];
                const savedData = matchingProducts.find(savedItem =>(item.product_code ||  item.product.productCode) === savedItem.product.productCode);
                finalOutputSection.push(savedData ? { ...savedData } : { ...item });
              }
              
          }

          if ((isEditQuotation || !supportingProduct[sectionIndex]?.products?.[productCode]) && !viewSupportingModal) {
            if(!isEditQuotation || (isEditQuotation && (!supportingProduct[sectionIndex]?.products?.[productCode] || supportingProduct[sectionIndex]?.products?.[productCode]?.length ==0))){
              finalOutputSection =  await fetchMainProductRelateSupportingProducts(productId);
            }
            setProductRelateSupportingProduct((prev) => ({
              ...prev,
              [sectionIndex]: {
                ...prev[sectionIndex],
                products: {
                  ...prev[sectionIndex]?.products,
                  [productCode]: finalOutputSection
                },
              },
            }));
          }
          setSectionData((prev)=>({...prev,name : section, sectionIndex : sectionIndex, pricingPolicy : pricingPolicy}))
        break;
        case 'SUB_SECTION':
          let finalOutputSubSection  = []
          const { index, subIdx } = sectionIndex;


            
            if(isEditQuotation && supportingProduct?.[index]?.[subIdx]?.[productCode]?.length !==0){
              /* 
              * FOR GETTING ALL SUPPORTING PRODUCT   
              */
              const productData = await fetchMainProductRelateSupportingProducts(productId);

              for (let item of productData) {
                const matchingProducts = supportingProduct?.[index]?.[subIdx]?.[productCode] || [];
                const savedData = matchingProducts.find(savedItem => (item.product_code ||  item.product.productCode)=== savedItem.product.productCode);

                
                finalOutputSubSection.push(savedData ? savedData : item);
              }
            }

            console.log("finalOutputSubSection-------->BEFORE", finalOutputSubSection);
          if ((isEditQuotation || !supportingProduct?.[index]?.[subIdx]?.[productCode]) && !viewSupportingModal) {
   
            try {

              
             if(!isEditQuotation || (isEditQuotation && (!supportingProduct[index][subIdx]?.[productCode] || supportingProduct[index][subIdx]?.[productCode].length ==0))){
                finalOutputSubSection =  await fetchMainProductRelateSupportingProducts(productId);
              }

              console.log("finalOutputSubSection-------->", finalOutputSubSection);
              

              setProductRelateSupportingProduct((prev) => {
                const prevSubSection = prev[index]?.[subIdx] || {};
                return {
                  ...prev,
                  [index]: {
                    ...prev[index],
                    [subIdx]: {
                      ...prevSubSection,
                      [productCode]: finalOutputSubSection,
                    },
                  },
                };
              });
            } catch (error) {
              console.error('Error fetching supporting product data:', error);
            }
          }
          setSectionData((prev)=>({...prev,name : section, subSectionIndex : sectionIndex, pricingPolicy : pricingPolicy}))
          break;
        case 'NO_SECTION':
          
          let finalOutputNoSection  = []
          if(isEditQuotation && supportingProduct?.[productCode]?.length !==0){
              /* 
               * FOR GETTING ALL SUPPORTING PRODUCT   
               */
              const productData = await fetchMainProductRelateSupportingProducts(productId);
              for (let item of productData) {
                const matchingProducts = supportingProduct[productCode] || [];

                
                const savedData = matchingProducts.find(savedItem => (item.product_code ||  item.product.productCode) === savedItem.product.productCode );
                finalOutputNoSection.push(savedData ? { ...savedData } : { ...item });
              }
          }

          
          if((isEditQuotation || !supportingProduct?.[productCode]) && !viewSupportingModal){
            if(!isEditQuotation || (isEditQuotation && (!supportingProduct?.[productCode] || supportingProduct[productCode].length ==0))){
              finalOutputNoSection =  await fetchMainProductRelateSupportingProducts(productId);
            }
            setProductRelateSupportingProduct((prev)=>({...prev, [productCode] : finalOutputNoSection}))
          }
          setSectionData((prev)=>({name : section, pricingPolicy : pricingPolicy}))
          break;
      }
      setProductCode(productCode)
      
      setViewSupportingModal(!viewSupportingModal);

      if (viewSupportingModal) {
        // # Reset 
      }
    // }catch(error){
    //   console.log("err", error);
      
    // }
  };


  // <---------------------------------------Formatting supporting product--------------------------------------------->
  const getDistributorDetails = useCallback(
    (distributor, initial_gpl_price, gpl_price ) => {


      
      if (gpl_price) return { value: '', label: 'No Distributor', gpl_price : gpl_price, initial_gpl_price : initial_gpl_price , noDistributor : true};
  
          return {
            label: (
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "4px 8px" }}>
                <span style={{ fontWeight: "500" }}>{distributor.name}</span>
                <button
                  type="button"
                  style={{
                    padding: "4px 8px",
                    border: "none",
                    backgroundColor: "#007bff",
                    color: "#fff",
                    borderRadius: "12px",
                    fontSize: "0.85em",
                    cursor: "pointer",
                  }}
                >
                  {distributor.currency} {distributor.initial_price}
                </button>
              </div>
            ),
            id : distributor.id,
            value: distributor.id,
            price: distributor.price,
            noDistributor : false,
            markup_price: distributor.markup_price,
            initial_price : distributor.initial_price,
            initial_gpl_price : initial_gpl_price 
          };
    },
    [] // No dependencies needed as we’re passing all dependencies as function arguments
  );
 

   useEffect(() => {
    const { sectionName, section ,sectionIndex} = formattedSavedProductsData

    switch(section){
      case 'MAIN_SECTION':  
          
        if((supportingProduct?.[sectionIndex] && !updatedProductSupportedData?.[sectionIndex]?.products?.[productCode]) && Object.keys(supportingProduct)?.length >0 && viewSupportingModal){    
            const supportingProductData = supportingProduct[sectionIndex].products[productCode]?.map((item) => { 

              const logistics = {
                custom_fee : item.custom_fee,
                logistic_buffer_charge : item.logistic_buffer_charge,
                logistic_fee :  item.logistic_fee
              }
              const distributorOption = getDistributorOptions(item.distributors, item.initial_gpl_price, item.gpl_price, logistics)
              const withoutMarkupPrice = distributorOption?.[0]?.price;
              const gplPrice = distributorOption?.[0]?.gpl_price;
              let standardMarkup = appStandardMarkup
              let quantity = 1;
              let discount = '0';
              let checked = false;
              let noDistributor = distributorOption?.[0]?.noDistributor
              let unitType  =  'Ea' || item.unit_type

              let logisticsCharge = item.logistic_fee;
              let customCharge = item.custom_fee;
              let bufferCharge  = item.logistic_buffer_charge;
              if (logisticsCharge <= 0) {
                logisticsCharge = 0;
              }
              if (customCharge <= 0) {
                customCharge = 0;
              }
              if (bufferCharge <= 0) {
                bufferCharge = 0;
              }

              // # Base price
              let basePrice  =  distributorOption?.[0]?.gpl_price || withoutMarkupPrice || 0
              let initialBasePrice =  distributorOption?.[0].initial_price || 0
              if(distributorOption?.[0].noDistributor){
                initialBasePrice =  distributorOption?.[0].initial_gpl_price || 0
              }
  
              let distributor = distributorOption?.[0];
              let initialGplPrice = item?.initial_gpl_price
              let pricingPolicyType = sectionData.pricingPolicy?.type;
              let distributorPriceWithMarkup = sectionData.pricingPolicy?.type == pricingPolicy.manufacture_discount.value ?
              // Case 3 Manufacture Discount 
              (parseFloat((basePrice)) * (1 - parseFloat((standardMarkup || 0)) / 100)).toFixed(2)
              :
              (parseFloat((basePrice)) * (1 + parseFloat((standardMarkup || 0)) / 100)).toFixed(2)

              let markupTotalPrice = sectionData.pricingPolicy?.type == pricingPolicy.manufacture_discount.value ?
              // Case 3 Manufacture Discount                                                                                              // quantity
              (parseFloat((parseFloat(( basePrice)) * (1 - parseFloat((standardMarkup  || 0) ) / 100)).toFixed(2)) * parseFloat(1)).toFixed(2) :

              (parseFloat((parseFloat(( basePrice )) * (1 + parseFloat((standardMarkup  || 0) ) / 100)).toFixed(2)) * parseFloat(1)).toFixed(2);

                // const shipmentCharge =    calculateTotalShipment(basePrice, logisticsCharge, customCharge, bufferCharge);
                // const markupFee = (
                //   parseFloat(basePrice || 0) * 
                //   ((parseFloat(appStandardMarkup || 0)) / 100)
                // ).toFixed(2);

              /* 
              * In the case of edit 
              */

              let product  =  { id: item.id,  productCode  :  item.product_code, name :  item.name } 
  
              console.log("item---> BEFORE MAIN", item);  
              if(isEditQuotation && item.distributor){
                console.log("item---> AFTER MAIN", item);      

                product  =  { id: item.product_id,  productCode  :  item.product_code, name :  item.product_name } 
                
                const selectedDistributor =  getDistributorDetails(item.distributor, item.initial_gpl_price,  item.gpl_price)  
                        
                const withoutMarkupPrice = selectedDistributor?.price;
                const gplPrice = selectedDistributor?.gpl_price

                // # Base price
                basePrice  =  gplPrice || withoutMarkupPrice || 0
                
                initialBasePrice = selectedDistributor.initial_price ;
                if(selectedDistributor.noDistributor){
                  initialBasePrice = selectedDistributor.initial_gpl_price;
                }

                // #Standard Markup
                standardMarkup = item.standard_markup || 0


                quantity = item.quantity || 1;
                discount = item.discount
                checked = true


              //  IF it is a new product
              if(item.isNewProduct){
                checked = false;
              }
                unitType = item.unit_type || 'Ea'
                noDistributor = selectedDistributor.noDistributor
                pricingPolicyType = item.pricing_policy
                distributorPriceWithMarkup = item.pricing_policy == pricingPolicy.manufacture_discount.value ?
                // Case 3 Manufacture Discount 
                (parseFloat((basePrice)) * (1 - parseFloat((standardMarkup)) / 100)).toFixed(2)
                :
                (parseFloat((basePrice)) * (1 + parseFloat((standardMarkup)) / 100)).toFixed(2)

                markupTotalPrice  = item.pricing_policy == pricingPolicy.manufacture_discount.value ?
                // Case 3 Manufacture Discount                                                                                              // quantity
                (parseFloat((parseFloat(( basePrice)) * (1 - parseFloat((standardMarkup) ) / 100)).toFixed(2)) * parseFloat(item.quantity || 1)).toFixed(2) :
    
                (parseFloat((parseFloat(( basePrice  )) * (1 + parseFloat((standardMarkup) ) / 100)).toFixed(2)) * parseFloat(item.quantity || 1)).toFixed(2)

                distributor = selectedDistributor
              } 
              if(item.product){
                product =  item.product
              }
              const shipmentCharge =    calculateTotalShipment(initialBasePrice, logisticsCharge, customCharge, bufferCharge);
              const  markupFee = (
                  parseFloat(basePrice || 0) * 
                  ((parseFloat(standardMarkup || 0)) / 100)
                ).toFixed(2);

              
              return {
                product: product,
                standard_markup: parseFloat(standardMarkup) || 0,
                isCertificateExpired: item.isCertificateExpired,
                quantity: quantity,
                unit_type: unitType,
                discount_value : discount,
                noDistributor : noDistributor,
                checked : checked,
                distributor: distributor,
                shipmentCharge : shipmentCharge,
                selectedSortOption : 'PRICE', // Default sort option
                markupFee : markupFee,
                initial_gpl_price : initialGplPrice,
                distributor_price_with_markup : distributorPriceWithMarkup,
                distributorOptions: distributorOption,
                markup_total_price : markupTotalPrice ,
                pricingPolicy : pricingPolicyType
              };
          });
          console.log("supportingProductData ------>Main Section", supportingProductData);
          
          // Correct state update to handle nested structure
          setUpdatedProductSupportedData((prev) => ({
              ...prev,
              [sectionIndex]: {
                  ...prev[sectionIndex],
                  products : {
                    ...prev[sectionIndex]?.products,
                    [productCode]: supportingProductData
                  }
                  // Ensure the specific productId is updated
              },
          }));
          
        }
        break;
      case 'SUB_SECTION':
        const {index, subIdx} = sectionIndex

     
          if (productRelateSupportingProduct?.[index] &&
            productRelateSupportingProduct[index]?.[subIdx] &&
            !updatedProductSupportedData?.[index]?.[subIdx]?.[productCode] &&
            Object.keys(productRelateSupportingProduct)?.length > 0
            && viewSupportingModal
          ) {
            const supportingProductData = productRelateSupportingProduct[index][subIdx]?.[productCode]?.map((item) => { 
              const logistics = {
                custom_fee : item.custom_fee,
                logistic_buffer_charge : item.logistic_buffer_charge,
                logistic_fee :  item.logistic_fee
              }
              
              const distributorOption = getDistributorOptions(item.distributors, item.initial_gpl_price, item.gpl_price, logistics)
              const withoutMarkupPrice = distributorOption?.[0]?.price;
              const gplPrice = distributorOption?.[0]?.gpl_price;

              let quantity = 1;
              let discount = '0';
              let checked = false;
              let noDistributor = distributorOption?.[0]?.noDistributor
              let unitType  =  'Ea' || item.unit_type

              let logisticsCharge = item.logistic_fee;
              let customCharge = item.custom_fee;
              let bufferCharge  = item.logistic_buffer_charge;
              if (logisticsCharge <= 0) {
                logisticsCharge = 0;
              }
              if (customCharge <= 0) {
                customCharge = 0;
              }
              if (bufferCharge <= 0) {
                bufferCharge = 0;
              }
              // # Markup
              let standardMarkup = appStandardMarkup
              // # Base price
              let basePrice  =  gplPrice || withoutMarkupPrice || 0;
              let initialBasePrice =  distributorOption?.[0].initial_price || 0
              if(distributorOption?.[0].noDistributor){
                initialBasePrice =  distributorOption?.[0].initial_gpl_price || 0
              }
  
              let pricingPolicyType = sectionData.pricingPolicy?.type;
              let distributor = distributorOption?.[0];
              let initialGplPrice = item?.initial_gpl_price
              let distributorPriceWithMarkup = sectionData.pricingPolicy?.type == pricingPolicy.manufacture_discount.value ?
              // Case 3 Manufacture Discount 
              (parseFloat((basePrice)) * (1 - parseFloat((standardMarkup || 0)) / 100)).toFixed(2)
              :
              (parseFloat((basePrice)) * (1 + parseFloat((standardMarkup || 0)) / 100)).toFixed(2)

              let markupTotalPrice = sectionData.pricingPolicy?.type == pricingPolicy.manufacture_discount.value ?
              // Case 3 Manufacture Discount                                                                                              // quantity
              (parseFloat((parseFloat(( basePrice)) * (1 - parseFloat((standardMarkup  || 0) ) / 100)).toFixed(2)) * parseFloat(1)).toFixed(2) :

              (parseFloat((parseFloat(( basePrice )) * (1 + parseFloat((standardMarkup  || 0) ) / 100)).toFixed(2)) * parseFloat(1)).toFixed(2);

              
              /* 
              * In the case of edit 
              */

              let  product  =  { id: item.id, name: item.name, productCode  :  item.product_code };
 
              console.log("item BEFORE", item);
              
              if(isEditQuotation && item.distributor){
;

                product = { id: item.product.id,  productCode  :  item.product.productCode, name :  item.product.name } 
                const selectedDistributor =  getDistributorDetails(item.distributor, item.initial_gpl_price,  item.gpl_price)  
                        
                const withoutMarkupPrice = selectedDistributor?.price;
                const gplPrice = selectedDistributor?.gpl_price

                initialBasePrice = selectedDistributor.initial_price ;
                if(selectedDistributor.noDistributor){
                  initialBasePrice = selectedDistributor.initial_gpl_price;
                }

                basePrice  =  gplPrice || withoutMarkupPrice || 0
                standardMarkup = item.standard_markup;

                quantity = item.quantity || 1;
                discount = item.discount
                checked = true
              //  IF it is a new product
              if(item.isNewProduct){
                checked = false;
              }
                unitType = item.unit_type || 'Ea'
                noDistributor = selectedDistributor.noDistributor
                pricingPolicyType = item.pricing_policy
                distributorPriceWithMarkup = item.pricing_policy == pricingPolicy.manufacture_discount.value ?
                // Case 3 Manufacture Discount 
                (parseFloat((basePrice)) * (1 - parseFloat((standardMarkup)) / 100)).toFixed(2)
                :
                (parseFloat((basePrice)) * (1 + parseFloat((standardMarkup)) / 100)).toFixed(2)

                markupTotalPrice  = item.pricing_policy == pricingPolicy.manufacture_discount.value ?
                // Case 3 Manufacture Discount                                                                                              // quantity
                (parseFloat((parseFloat(( basePrice)) * (1 - parseFloat((standardMarkup) ) / 100)).toFixed(2)) * parseFloat(item.quantity || 1)).toFixed(2) :
    
                (parseFloat((parseFloat(( basePrice )) * (1 + parseFloat((standardMarkup) ) / 100)).toFixed(2)) * parseFloat(item.quantity || 1)).toFixed(2)

                distributor = selectedDistributor
              }
              const shipmentCharge =    calculateTotalShipment(initialBasePrice, logisticsCharge, customCharge, bufferCharge)
              const  markupFee = (
                  parseFloat(basePrice || 0) * 
                  ((parseFloat(standardMarkup || 0)) / 100)
                ).toFixed(2);
                if(item.product){
                  product =  item.product
                }
              return {
                product: product,
                standard_markup: parseFloat(standardMarkup) || 0,
                isCertificateExpired: item.isCertificateExpired,
                quantity: quantity,
                unit_type: unitType,
                discount_value : discount,
                noDistributor : noDistributor,
                checked : checked,
                distributor: distributor,
                shipmentCharge : shipmentCharge,
                selectedSortOption : 'PRICE', // Default sort option
                markupFee : markupFee,
                initial_gpl_price : initialGplPrice,
                distributor_price_with_markup : distributorPriceWithMarkup,
                distributorOptions: distributorOption,
                markup_total_price : markupTotalPrice ,
                pricingPolicy : pricingPolicyType
              };
            }); 

          setUpdatedProductSupportedData((prev) => {
            return {
              ...prev,
              [index]: {
                ...(prev[index] || {}), // Ensure `prev[index]` exists
                [subIdx]: {
                  ...(prev[index]?.[subIdx] || {}), // Ensure `prev[index][subIdx]` exists
                  [productCode]: supportingProductData, // Add or update the product ID data
                },
              },
            };
          });;     
        }
        break;
      case 'NO_SECTION':
        if(!updatedProductSupportedData[productCode]){
          const supportingProductData = supportingProduct[productCode]?.map((item) => { 
            const logistics = {
              custom_fee : item.custom_fee,
              logistic_buffer_charge : item.logistic_buffer_charge,
              logistic_fee :  item.logistic_fee
            }
            console.log("**********>>>>>>>>>", logistics);
            
            const distributorOption = getDistributorOptions(item.distributors, item.initial_gpl_price, item.gpl_price, logistics)
            const withoutMarkupPrice = distributorOption?.[0]?.price;
            const gplPrice = distributorOption?.[0]?.gpl_price;

            let quantity = 1;
            let discount = '0';
            let checked = false;
            let noDistributor = distributorOption?.[0]?.noDistributor
            let unitType  =  'Ea' || item.unit_type

            let logisticsCharge = item.logistic_fee;
            let customCharge = item.custom_fee;
            let bufferCharge  = item.logistic_buffer_charge;
            if (logisticsCharge <= 0) {
              logisticsCharge = 0;
            }
            if (customCharge <= 0) {
              customCharge = 0;
            }
            if (bufferCharge <= 0) {
              bufferCharge = 0;
            }
            // # Markup
            let standardMarkup = appStandardMarkup
            // # Base price
            let basePrice  =  gplPrice || withoutMarkupPrice || 0
              console.log("distributorOption-->", distributorOption);

            let initialBasePrice =  distributorOption?.[0].initial_price || 0
            if(distributorOption?.[0].noDistributor){
              initialBasePrice =  distributorOption?.[0].initial_gpl_price || 0
            }

            let distributor = distributorOption?.[0];
            let initialGplPrice = item?.initial_gpl_price;
            let pricingPolicyType =  sectionData.pricingPolicy?.type;
            let distributorPriceWithMarkup = sectionData.pricingPolicy?.type == pricingPolicy.manufacture_discount.value ?
            // Case 3 Manufacture Discount 
            (parseFloat((basePrice)) * (1 - parseFloat((standardMarkup || 0)) / 100)).toFixed(2)
            :
            (parseFloat((basePrice)) * (1 + parseFloat((standardMarkup || 0)) / 100)).toFixed(2)

            let markupTotalPrice = sectionData.pricingPolicy?.type == pricingPolicy.manufacture_discount.value ?
            // Case 3 Manufacture Discount                                                                                              // quantity
            (parseFloat((parseFloat(( basePrice)) * (1 - parseFloat((standardMarkup  || 0) ) / 100)).toFixed(2)) * parseFloat(1)).toFixed(2) :

            (parseFloat((parseFloat(( basePrice )) * (1 + parseFloat((standardMarkup  || 0) ) / 100)).toFixed(2)) * parseFloat(1)).toFixed(2)

            /* 
            * In the case of edit 
            */ 
           let product = { id: item.id, name: item.name, productCode  :  item.product_code };

            if(isEditQuotation && item.distributor){
              product = { id: item.product.id,  productCode  :  item.product.productCode, name :  item.product.name } 
               const selectedDistributor =  getDistributorDetails(item.distributor, item.initial_gpl_price, item.gpl_price)  
                        
               const withoutMarkupPrice = selectedDistributor?.price;
               const gplPrice = selectedDistributor?.gpl_price
                initialBasePrice = selectedDistributor.initial_price ;
                if(selectedDistributor.noDistributor){
                  initialBasePrice = selectedDistributor.initial_gpl_price;
                }
               

               basePrice  =  gplPrice || withoutMarkupPrice || 0
               standardMarkup = item.standard_markup;

               quantity = item.quantity || 1;
               discount = item.discount
               checked = true

               
              //  IF it is a new product
              if(item.isNewProduct){
                checked = false;
              }
               unitType = item.unit_type || 'Ea'
               noDistributor = selectedDistributor.noDistributor
               pricingPolicyType = item.pricing_policy
               distributorPriceWithMarkup = item.pricing_policy == pricingPolicy.manufacture_discount.value ?
               // Case 3 Manufacture Discount 
               (parseFloat((basePrice)) * (1 - parseFloat((standardMarkup)) / 100)).toFixed(2)
               :
               (parseFloat((basePrice)) * (1 + parseFloat((standardMarkup)) / 100)).toFixed(2)

               markupTotalPrice  = item.pricing_policy == pricingPolicy.manufacture_discount.value ?
               // Case 3 Manufacture Discount                                                                                              // quantity
               (parseFloat((parseFloat(( basePrice)) * (1 - parseFloat((standardMarkup) ) / 100)).toFixed(2)) * parseFloat(item.quantity || 1)).toFixed(2) :
   
               (parseFloat((parseFloat(( basePrice )) * (1 + parseFloat((standardMarkup) ) / 100)).toFixed(2)) * parseFloat(item.quantity || 1)).toFixed(2)

               distributor = selectedDistributor
            }

            if(item.product){
              product =  item.product
             }

            const shipmentCharge =    calculateTotalShipment(initialBasePrice, logisticsCharge, customCharge, bufferCharge);

            const  markupFee =  calculatePrice('MARKUP_FEE', ( item.pricing_policy  || pricingPolicy.standard_pricing.value), basePrice,standardMarkup,'')
            return {
              product: product,
              standard_markup: parseFloat(standardMarkup) || 0,
              isCertificateExpired: item.isCertificateExpired,
              quantity: quantity,
              unit_type: unitType,
              discount_value : discount,
              noDistributor : noDistributor,
              checked : checked,
              distributor: distributor,
              shipmentCharge : shipmentCharge,
              markupFee : markupFee,
              selectedSortOption : 'PRICE', // Default sort option
              initial_gpl_price : initialGplPrice,
              distributor_price_with_markup : distributorPriceWithMarkup,
              distributorOptions: distributorOption,
              markup_total_price : markupTotalPrice ,
              pricingPolicy : pricingPolicyType
            };
          });    
          console.log("supportingProductData ------>NO_SECTION", supportingProductData);
          setUpdatedProductSupportedData((prev)=>({...prev, [productCode] : supportingProductData}))
        }
        break;
    }

  }, [supportingProduct, productRelateSupportingProduct, appStandardMarkup, productCode, sectionData]);

  // <---------------------------------------Formatting supporting product END-------------------------------------------->



  useEffect(() => {
    // if (productRelateSupportingProduct.length > 0 ) {
      const { sectionName, section } = formattedSavedProductsData
      if(sectionName){
        // Section 
        switch(section){
          case 'MAIN_SECTION':
            setSectionBaseSavedProducts((prevSections) =>(
              {
                ...prevSections,
                [formattedSavedProductsData.sectionIndex] : {
                  ...sectionBaseSavedProducts[formattedSavedProductsData.sectionIndex],
                  products : sectionBaseSavedProducts[formattedSavedProductsData.sectionIndex].products?.map((mainSectionProduct,mainSectionProductIdx)=>
                  (
                    // Only main products
                    (mainSectionProduct.product.productCode == productCode && mainSectionProduct.isChildProductsAvailable) ?
                    {
                      ...mainSectionProduct,
                      supportedProducts : updatedProductSupportedData?.[formattedSavedProductsData.sectionIndex]?.products?.[productCode]
                    } : mainSectionProduct
                  ))
              }
              }
            ))
            break
          case 'SUB_SECTION':

            
            
            
            
            const {index, subIdx} = formattedSavedProductsData.sectionIndex        

            setSectionBaseSavedProducts((prevSections) =>(
              {
                ...prevSections,
                [index] : {
                  ...prevSections[index],
                  subSections : {
                    // ...sectionBaseSavedProducts[index].subSections?.[subIdx],
                    ...prevSections[index].subSections,
                    [subIdx] :prevSections[index].subSections?.[subIdx]?.map((subSectionProduct,subSectionProductIdx)=>
                    (
                      // Only main products
                      (subSectionProduct.product.productCode == productCode && subSectionProduct.isChildProductsAvailable)?
                      {
                        ...subSectionProduct,
                        supportedProducts : updatedProductSupportedData?.[index]?.[subIdx]?.[productCode]
                      } : subSectionProduct
                    ))
                }
              }
              }
            ))
            break
          default:
            console.log("Unknown section");
            break
        }  
      }else{
        
        // No section
          setNotSectionBaseSaveProducts((prev)=>(
            prev.map((item,index)=>(
              // Only main products
              (item.product.productCode == productCode && item.isChildProductsAvailable) ? 
              {
                ...item,
                supportedProducts : updatedProductSupportedData
              } : item
            ))
        ))
      }
 
    // }
  }, [ updatedProductSupportedData, productCode]);



  const handleDeleteSavedProduct =(productCode)=>{
    const { section, sectionIndex } = formattedSavedProductsData


 
    switch(section){
      case 'MAIN_SECTION':

        setSectionBaseSavedProducts((prevSections) =>(
          {
            ...prevSections,
            [sectionIndex] : {
              ...sectionBaseSavedProducts[sectionIndex],
              products : sectionBaseSavedProducts[sectionIndex].products?.filter((mainSectionProduct,mainSectionProductIdx)=>
              (
                mainSectionProduct.product.productCode !== productCode 
              ))
          }
          }
        ))

        // Deleting product from supporting product
        if (updatedProductSupportedData[sectionIndex]?.products?.[productCode]) {
          setUpdatedProductSupportedData((prevSections) => {
            const updatedSections = { ...prevSections };
        
            // Make a deep copy of the nested structure
            const mainSectionProductsCopy = { ...updatedSections[sectionIndex].products };
        
            // Remove the productCode key
            delete mainSectionProductsCopy[productCode];
        
            // Update the nested structure
            updatedSections[sectionIndex] = {
              ...updatedSections[sectionIndex],
              products: mainSectionProductsCopy
            };
        
            return updatedSections;
          });
        }
        // if(isEditQuotation){
          // setQuotationProductData((prevSections)=>

          //   prevSections.map((mainSection, mainSecIndex)=>
          //     mainSecIndex ==sectionIndex ?
          //       {
          //         ...mainSection,
          //         products : mainSection.products.filter((prdItem)=>(prdItem.product_code !== productCode))
          //       }: mainSection
          //   )
          // )

          setSectionItems((prev)=>
            prev.map((mainSectionItem, mainSecIndex)=>
              mainSecIndex ==  sectionIndex
              ? {
                  ...mainSectionItem,
                  filteredProductData :  mainSectionItem.filteredProductData.filter((item)=>(item.product_code !== productCode)),
                  productData :  mainSectionItem.productData.filter((item)=>(item.product_code !== productCode)),
                } : mainSectionItem
            )
          )
          setIsUpdateProductButtonSection((prevSection) => {
            const updatedSection = { ...prevSection }; // Shallow copy of the object
            const mainSectionCopy = { ...updatedSection[sectionIndex] }; // Shallow copy of the specific section object
          
            // Ensure nested structure exists before updating
            if (mainSectionCopy[sectionIndex] !== undefined) {
              mainSectionCopy[sectionIndex] = false; // Set the value to false
            }
          
            updatedSection[sectionIndex] = mainSectionCopy; // Update the specific section in the object
            return updatedSection; // Return the updated object
          });
          
        // }

        // ----------------------------------------------------------------------------STOPPED HERE---------------------------------------------------------------
        break
      case 'SUB_SECTION':
        const {index, subIdx} = sectionIndex; 
        setSectionBaseSavedProducts((prevSections) =>(
          {
            ...prevSections,
            [index] : {
              ...prevSections[index],
              subSections : {
                // ...sectionBaseSavedProducts[index].subSections?.[subIdx],
                ...prevSections[index].subSections,
                [subIdx] :prevSections[index].subSections?.[subIdx]?.filter((subSectionProduct,subSectionProductIdx)=>
                (
                  subSectionProduct.product.productCode !== productCode 
                ))
            }
          }
          }
        ))

        
          // Deleting product from supporting product
          if (updatedProductSupportedData[index]?.[subIdx]?.[productCode]) {
            setUpdatedProductSupportedData((prevSections) => {
              const updatedSections = { ...prevSections };
          
              // Make a deep copy of the nested structure
              const subSectionCopy = { ...updatedSections[index][subIdx] };
          
              // Remove the productCode key
              delete subSectionCopy[productCode];
          
              // Update the nested structure
              updatedSections[index] = {
                ...updatedSections[index],
                [subIdx]: subSectionCopy,
              };
          
              return updatedSections;
            });
          }
          // if(isEditQuotation){
              // setQuotationProductData((prevSections)=>

              //   prevSections.map((mainSection, mainSecIndex)=>
              //     mainSecIndex ==index ?
              //       {
              //         ...mainSection,
              //         sub_sections : mainSection.sub_sections.map((subSecItem, subSecIdx)=>
              //           subSecIdx == subIdx ? 
              //           {
              //             ...subSecItem,
              //             products :  subSecItem.products.filter((prdItem)=>(prdItem.product_code !== productCode))
              //           } : subSecItem
              //         )
              //       }: mainSection
              //   )
              // )
              setSectionItems((prev)=>
                prev.map((mainSectionItem, mainSecIndex)=>
                  mainSecIndex ==  index
                  ? {
                      ...mainSectionItem,
                      subSections :  mainSectionItem.subSections.map((subSecItem, subSecIndex)=>
                        subSecIndex == subIdx 
                      ? {
                          ...subSecItem,
                          filteredProductData :  subSecItem.filteredProductData.filter((item)=>(item.product_code !== productCode)),
                          productData :  subSecItem.productData.filter((item)=>(item.product_code !== productCode)),
                        } : subSecItem
                      )
                    } : mainSectionItem
                )
              )
              
              setIsUpdateProductButtonSection((prevSection) => {
                const updatedSection = { ...prevSection }; // Shallow copy of the object
                const mainSectionCopy = { ...updatedSection[index] }; // Shallow copy of the main section object
                const subSectionCopy = { ...mainSectionCopy.subSections }; // Shallow copy of the subSections object
              
                // Ensure nested structure exists before updating
                if (subSectionCopy[subIdx] !== undefined) {
                  subSectionCopy[subIdx] = false; // Set the value to false
                }
              
                mainSectionCopy.subSections = subSectionCopy; // Update the subSections property
                updatedSection[index] = mainSectionCopy; // Update the specific section in the object
                return updatedSection; // Return the updated object
              });
              
          //  }
           if(productRelateSupportingProduct?.[index]?.[subIdx]){
            setProductRelateSupportingProduct((prevSections)=>{
              const updatedSections = { ...prevSections };
            
              // Make a deep copy of the nested structure
              const subSectionCopy = { ...updatedSections[index][subIdx] };
          
              // Remove the productCode key
              delete subSectionCopy[productCode];
              // Update the nested structure
              updatedSections[index] = {
                ...updatedSections[index],
                [subIdx]: subSectionCopy,
              };
          
              return updatedSections;
            })
           }

  
          
        break
      case 'NO_SECTION':
          setNotSectionBaseSaveProducts((prev)=>(
            prev?.filter((item,index)=>(
              item.product?.productCode != productCode 
            ))
          ))
          // Deleting product from supporting product
        if(updatedProductSupportedData[productCode]){
          setUpdatedProductSupportedData((prev)=>{
            const updatedData = { ...prev };
      
            // Remove the property
            delete updatedData[productCode];
            return updatedData || {}
          })
        }
        // if(isEditQuotation){
        // Deleting product from product list 
        // setQuotationProductData((prev)=>{
        //   const filterData= prev?.filter((item)=>(item.product_code !== productCode))
        //   return filterData
        // })
        setIsUpdateProductButtonNoSection(true)
        // }
        setSelectedProduct((prev) => {
          const filteredProduct = prev.filteredProductData.filter(
            (item) => item.product_code !== productCode
          );
          const updatedProductData = prev.productData.filter(
            (item) => item.product_code !== productCode
          );
        
          return {
            ...prev, // Retain other properties of the previous state
            filteredProductData: filteredProduct,
            productData: updatedProductData,
          };
        });
        
        setProductRelateSupportingProduct((prev)=>{
          const updatedData = {...prev}
          delete updatedData[productCode];
          return updatedData
        })

        break
      default:
        console.log("Unknown section");
        break
    }
  }

  const viewModalProps={
    viewSupportingModal,
    handleShowSupportingProductViewModal,
    updatedProductSupportedData,
    setUpdatedProductSupportedData,
    productCode,
    sectionData
  }

  return (
    <Modal   contentClassName="custom-view-list-content"      fullscreen={true}  size="xl" isOpen={viewModal} toggle={handleShowViewModal}>
      <div style={{maxHeight : '850px', overflow : 'auto'}}>
        <ModalHeader toggle={handleShowViewModal}>Product List </ModalHeader>
        <ModalBody>
            <Card className="p-2">
                {formattedSavedProductsData?.sectionName && <h4>
                    Section:{" "}
                    <b className="text-success">
                        {formattedSavedProductsData?.sectionName || "N/A"}
                    </b>
                </h4>}
                <Table size="xl" striped bordered >
                <thead>
                <tr className="table-secondary">
                    <th>#</th>
                    <th>Product</th>
                    <th>Unit type</th>
                    <th>Quantity</th>
                    <th>U.Cost</th>
                    <th>T.Cost</th>
                    <th>Markup(%)</th>
                    <th>U.Price</th>
                    <th>T.Price</th>
                    <th>Discount</th>
                    <th>U.Price (Vendor)</th>
                    <th>T.Price (Vendor)</th>
                    <th>Total Profit</th>
                    <th>Supporting Products</th>
                    <th>Action</th>
                </tr>
                </thead>
                <tbody>
                    {formattedSavedProductsData?.products?.map((item,index)=>(
                        <tr key={index} className="table-primary">
                            <th scope="row">{index+1}</th>
                            <td style={{maxWidth : '150px'}}>{item.product.name}</td>
                            <td>{item.unit_type}</td>
                            <td>{item.quantity}</td>
                            <td>{item.u_cost}</td>
                            <td>{item.t_cost}</td> 
                            <td>{parseFloat(item.standard_markup).toString()} %</td>
                            <td>{item.u_price}</td>
                            <td>{item.t_price}</td>
                            <td>{parseFloat(item.v_discount) ?`${parseFloat(item.v_discount)} %` : ''}</td>
                            <td>{item.v_unit_cost}</td>
                            <td>{item.v_total_cost}</td>
                            <td>{item.v_total_profit}</td>
                            <td > 
                              <div className="d-flex justify-content-center align-items-center">
                                {item.isChildProductsAvailable && <Button
                                  color="info"
                                  onClick={(e) => {
                                    if (item?.product) {
                                      handleShowSupportingProductViewModal(
                                        item.product.id,
                                        item.product.product_code,
                                        item.pricing_policy
                                      );
                                    } else {
                                      console.error("Product details are missing!");
                                    }
                                  }}
                                >
                                  View products
                                </Button>}
                                {/* Trash */}

                              </div>
                            </td>
                          <td>
                          <button type="button"
                             style={{
                                  display : 'block',
                                  marginLeft: '10px',
                                  border : 'none'
                             }}
                             onClick={(e)=>handleDeleteSavedProduct(item.product.product_code)}
                             >
                              <span style={{fontSize :'25px', fontWeight : 600, color : 'black'}}>
                                <i class="bi bi-trash-fill"></i>
                              </span>
                           </button>
                          </td>
                        </tr>
                    ))}
                </tbody>
                </Table>
                <ViewSupportingProductPopUp {...viewModalProps}/>
            </Card>
          
        </ModalBody>
      </div>
    </Modal>
  );
};

export default ViewPopUp;
